/** `GET /api/v1/health` — App Platform's probe. No auth, no data. */
import { z } from 'zod';
export const HealthResponse = z
    .object({
    /** `true` only when the database answered. */
    ok: z.boolean(),
    /** Build version (git sha or semver) of the running API. */
    version: z.string(),
    db: z.enum(['up', 'down']),
})
    .meta({ id: 'HealthResponse' });
//# sourceMappingURL=system.js.map